(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-luxe-loader"]) return;
  try {
    
(() => {
 const SELECTORS = {
  main: '[id$="__main"]',
  productTitle: 'h1',
  variantOption: '[data-variant-option]',

    quantitySelector: '[data-quantity-selector]',
    quantityInput: '[data-quantity-input]',

    quantityButton:
      '[data-quantity-plus], [data-quantity-minus]',

    buttonWrapper: '[data-button-wrapper]',
    minusWrapper: '[data-button-wrapper-minus]',
    plusWrapper: '[data-button-wrapper-plus]'
  };

  const DISABLED_WRAPPER_CLASS =
    'quantity-selector__button-wrapper--disabled';

  const getMainProduct = () =>
    document.querySelector(SELECTORS.main);

  const isSimpleProduct = (main) =>
    !main.querySelector(SELECTORS.variantOption);

  /* --------------------------------
   * Quantity-fallback
   * -------------------------------- */

  const updateQuantityButtonStates = (
    selector,
    input
  ) => {
    const value = Number(input.value);

    const min =
      input.min === ''
        ? 1
        : Number(input.min);

    const max =
      input.max === ''
        ? Infinity
        : Number(input.max);

    selector
      .querySelector(SELECTORS.minusWrapper)
      ?.classList.toggle(
        DISABLED_WRAPPER_CLASS,
        value <= min
      );

    selector
      .querySelector(SELECTORS.plusWrapper)
      ?.classList.toggle(
        DISABLED_WRAPPER_CLASS,
        Number.isFinite(max) && value >= max
      );
  };

  const dispatchQuantityEvents = (input) => {
    input.dispatchEvent(
      new Event('input', {
        bubbles: true
      })
    );

    input.dispatchEvent(
      new Event('change', {
        bubbles: true
      })
    );
  };

  const handleQuantityClick = (event) => {
    if (!(event.target instanceof Element)) return;

    const button = event.target.closest(
      SELECTORS.quantityButton
    );

    if (!button) return;

    const main = button.closest(
      SELECTORS.main
    );

    /*
     * Alleen gebruiken bij eenvoudige producten
     * zonder kleur- of maatopties.
     */
    if (!main || !isSimpleProduct(main)) return;

    const selector = button.closest(
      SELECTORS.quantitySelector
    );

    const input = selector?.querySelector(
      SELECTORS.quantityInput
    );

    const wrapper = button.closest(
      SELECTORS.buttonWrapper
    );

    if (!selector || !input || button.disabled) {
      return;
    }

    if (
      wrapper?.classList.contains(
        DISABLED_WRAPPER_CLASS
      )
    ) {
      return;
    }

    const valueBeforeClick = input.value;

    requestAnimationFrame(() => {
      /*
       * Eerst krijgt het normale themescript
       * de kans om het aantal te wijzigen.
       */
      if (input.value !== valueBeforeClick) {
        return;
      }

      try {
        if (
          button.matches('[data-quantity-plus]')
        ) {
          input.stepUp();
        } else {
          input.stepDown();
        }
      } catch (error) {
        return;
      }

      updateQuantityButtonStates(
        selector,
        input
      );

      dispatchQuantityEvents(input);
    });
  };

  const handleQuantityInput = (event) => {
    if (!(event.target instanceof Element)) return;

    const input = event.target.closest(
      SELECTORS.quantityInput
    );

    if (!input) return;

    const main = input.closest(
      SELECTORS.main
    );

    if (!main || !isSimpleProduct(main)) return;

    const selector = input.closest(
      SELECTORS.quantitySelector
    );

    if (!selector) return;

    updateQuantityButtonStates(
      selector,
      input
    );
  };
const getShareUrl = () => {
  const url = new URL(window.location.href);
  const variant = url.searchParams.get('variant');

  url.search = '';
  url.hash = '';

  if (variant) {
    url.searchParams.set('variant', variant);
  }

  return url.toString();
};

const fallbackCopy = (text) => {
  const textarea = document.createElement('textarea');
  textarea.value = text;
  textarea.setAttribute('readonly', '');
  textarea.style.position = 'fixed';
  textarea.style.opacity = '0';

  document.body.appendChild(textarea);
  textarea.select();

  const copied = document.execCommand('copy');

  textarea.remove();

  return copied;
};

const showShareFeedback = (button) => {
  button.classList.add('is-copied');
  button.setAttribute('aria-label', 'Link gekopieerd');

  window.setTimeout(() => {
    button.classList.remove('is-copied');
    button.setAttribute('aria-label', 'Deel dit product');
  }, 1800);
};

const handleShareClick = async (event) => {
  if (!(event.target instanceof Element)) return;

  const button = event.target.closest(
    '[data-luxe-share-button]'
  );

  if (!button) return;

  const main = getMainProduct();

  const title =
    main
      ?.querySelector(SELECTORS.productTitle)
      ?.textContent
      ?.replace(/\s+/g, ' ')
      .trim() || document.title;

  const url = getShareUrl();

  if (navigator.share) {
    try {
      await navigator.share({
        title,
        url
      });

      return;
    } catch (error) {
      if (error?.name === 'AbortError') return;
    }
  }

  try {
    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(url);
    } else if (!fallbackCopy(url)) {
      return;
    }

    showShareFeedback(button);
  } catch (error) {
    if (fallbackCopy(url)) {
      showShareFeedback(button);
    }
  }
};

const ensureShareButton = () => {
  const main = getMainProduct();

  if (!main) return;

  if (
    main.querySelector(
      '[data-luxe-share-button]'
    )
  ) {
    return;
  }

  const title = main.querySelector(
    SELECTORS.productTitle
  );

  if (!title || !title.parentNode) return;

  const row = document.createElement('div');

  row.className = 'luxe-product-title-row';

  title.parentNode.insertBefore(
    row,
    title
  );

  row.appendChild(title);

  const button = document.createElement(
    'button'
  );

  button.type = 'button';

  button.className = 'luxe-product-share';

  button.setAttribute(
    'data-luxe-share-button',
    ''
  );

  button.setAttribute(
    'aria-label',
    'Deel dit product'
  );

  button.innerHTML = `
    <svg
      viewBox="0 0 24 24"
      aria-hidden="true"
      focusable="false"
    >
      <path
        d="M12 3v12M7.5 7.5 12 3l4.5 4.5M5 12.5v6A2.5 2.5 0 0 0 7.5 21h9a2.5 2.5 0 0 0 2.5-2.5v-6"
      />
    </svg>

    <span
      class="luxe-product-share__feedback"
      aria-hidden="true"
    >
      Gekopieerd
    </span>
  `;

  row.appendChild(button);
};

document.addEventListener(
  'click',
  handleQuantityClick,
  true
);

document.addEventListener(
  'click',
  handleShareClick
);

document.addEventListener(
  'input',
  handleQuantityInput
);

const initShareButton = () => {
  requestAnimationFrame(
    ensureShareButton
  );
};

if (document.readyState === 'loading') {
  document.addEventListener(
    'DOMContentLoaded',
    initShareButton,
    {
      once: true
    }
  );
} else {
  initShareButton();
}

document.addEventListener(
  'shopify:section:load',
  initShareButton
);

})();

/* --------------------------------
 * Also Bought
 * Onder Shop de collectie
 * -------------------------------- */
/* --------------------------------
 * Maattabel proxy
 * -------------------------------- */

(() => {
  let sizeChartFrame = null;

  const getMainProduct = () =>
    document.querySelector('[id$="__main"]') ||
    document.querySelector('.product--section');

  const findSizeRow = (main) => {
    const directRow = main.querySelector(
      '.options-selection__option-values[data-variant-option-index="1"]'
    );

    if (directRow) return directRow;

    const optionGroups = Array.from(
      main.querySelectorAll('[data-variant-option]')
    );

    const namedGroup = optionGroups.find((group) => {
      const fieldset = group.closest('fieldset');
      const legend = fieldset?.querySelector('legend');
      const label = legend?.textContent || '';

      return /^\s*(maat|size)\b/i.test(label);
    });

    if (!namedGroup) return null;

    return (
      namedGroup.querySelector(
        '.options-selection__option-values'
      ) || namedGroup
    );
  };

  const getOriginalButtons = (main) => {
    const buttonsInMain = Array.from(
      main.querySelectorAll(
        '.pl-size-charts__button'
      )
    );

    if (buttonsInMain.length > 0) {
      return buttonsInMain;
    }

    return Array.from(
      document.querySelectorAll(
        '.pl-size-charts__button'
      )
    );
  };

  const markOriginalButtons = (main) => {
    const buttons = getOriginalButtons(main);

    buttons.forEach((button) => {
      button.setAttribute(
        'data-luxe-size-chart-original',
        ''
      );

      button.setAttribute('tabindex', '-1');
      button.setAttribute('aria-hidden', 'true');

      /*
       * De echte app-knop blijft bestaan,
       * maar wordt visueel verborgen.
       */
      const hiddenStyles = {
        position: 'absolute',
        width: '1px',
        height: '1px',
        'min-width': '1px',
        'min-height': '1px',
        margin: '-1px',
        padding: '0',
        overflow: 'hidden',
        clip: 'rect(0 0 0 0)',
        'clip-path': 'inset(50%)',
        'white-space': 'nowrap',
        border: '0'
      };

      Object.entries(hiddenStyles).forEach(
        ([property, value]) => {
          button.style.setProperty(
            property,
            value,
            'important'
          );
        }
      );

      const wrapper =
        button.closest(
          '[data-block-handle="size_charts_button"]'
        ) ||
        button.closest('.shopify-block') ||
        button.closest('.product-block');

      if (wrapper) {
        wrapper.setAttribute(
          'data-luxe-size-chart-original-wrapper',
          ''
        );

        wrapper.style.setProperty(
          'margin',
          '0',
          'important'
        );

        wrapper.style.setProperty(
          'padding',
          '0',
          'important'
        );

        wrapper.style.setProperty(
          'min-height',
          '0',
          'important'
        );
      }
    });

    return buttons;
  };

  const getCurrentOriginalButton = (main) => {
    const buttons = markOriginalButtons(main);

    return (
      buttons.find(
        (button) => button.isConnected
      ) || null
    );
  };

  const ensureSizeChartProxy = () => {
    const main = getMainProduct();

    if (!main) return;

    const sizeRow = findSizeRow(main);

    const originalButton =
      getCurrentOriginalButton(main);

    if (!sizeRow || !originalButton) return;

    sizeRow.setAttribute(
      'data-luxe-size-row',
      ''
    );

    let proxy = sizeRow.querySelector(
      '[data-luxe-size-chart-proxy]'
    );

    if (!proxy) {
      proxy = document.createElement('button');

      proxy.type = 'button';
      proxy.className =
        'luxe-size-chart-proxy';

      proxy.setAttribute(
        'data-luxe-size-chart-proxy',
        ''
      );

      proxy.addEventListener(
        'click',
        (event) => {
          event.preventDefault();

          const currentMain =
            getMainProduct();

          if (!currentMain) return;

          const currentOriginal =
            getCurrentOriginalButton(
              currentMain
            );

          currentOriginal?.click();
        }
      );

      sizeRow.append(proxy);
    }

    /*
     * Gebruik exact hetzelfde icoon en
     * dezelfde tekst als de app.
     */
    if (
      proxy.innerHTML !==
      originalButton.innerHTML
    ) {
      proxy.innerHTML =
        originalButton.innerHTML;
    }

    const label =
      originalButton.getAttribute(
        'aria-label'
      ) ||
      originalButton.textContent
        ?.replace(/\s+/g, ' ')
        .trim() ||
      'Maattabel';

    proxy.setAttribute(
      'aria-label',
      label
    );
  };

  const scheduleSizeChartProxy = () => {
    if (sizeChartFrame !== null) {
      cancelAnimationFrame(
        sizeChartFrame
      );
    }

    sizeChartFrame =
      requestAnimationFrame(() => {
        sizeChartFrame = null;
        ensureSizeChartProxy();
      });
  };

  scheduleSizeChartProxy();

  new MutationObserver(
    scheduleSizeChartProxy
  ).observe(
    document.documentElement,
    {
      childList: true,
      subtree: true
    }
  );

  document.addEventListener(
    'shopify:section:load',
    scheduleSizeChartProxy
  );
})();
let alsoBoughtObserver = null;
let alsoBoughtFrame = null;

const moveAlsoBoughtToBottom = () => {
  const alsoBought = document.querySelector(
    '.cbb-also-bought-container'
  );

  const siteMain = document.getElementById(
    'site-main'
  );

  if (!alsoBought || !siteMain) {
    return false;
  }

  /*
   * Bestaande luxe styling behouden.
   */
  alsoBought.setAttribute(
    'data-luxe-also-bought',
    ''
  );

  /*
   * Altijd helemaal onderaan de pagina-inhoud,
   * direct vóór de footer.
   */
  if (siteMain.lastElementChild !== alsoBought) {
    siteMain.appendChild(alsoBought);
  }

  return true;
};

const scheduleAlsoBoughtMove = () => {
  if (alsoBoughtFrame !== null) {
    cancelAnimationFrame(alsoBoughtFrame);
  }

  alsoBoughtFrame = requestAnimationFrame(() => {
    alsoBoughtFrame = null;
    moveAlsoBoughtToBottom();
  });
};

const startAlsoBoughtMove = () => {
  moveAlsoBoughtToBottom();

  if (alsoBoughtObserver) {
    return;
  }

  alsoBoughtObserver = new MutationObserver(() => {
    scheduleAlsoBoughtMove();
  });

  alsoBoughtObserver.observe(
    document.body,
    {
      childList: true,
      subtree: true
    }
  );
};

startAlsoBoughtMove();

document.addEventListener(
  'shopify:section:load',
  startAlsoBoughtMove
);

  } catch(e) { console.error(e); }
})();
})();
